export default "__VITE_ASSET__DhrXO8R$__"